module.exports = __webpack_public_path__ + "static/mobile-1-fb0e4f069aa136078e012d31bdd90594.png";